import Image from 'next/image';

import { P } from '~components/Typography';

import { NeuronsCost } from './NeuronsBadge.styles';

type TNeuronsBadge = {
	showPrice: boolean;
	cost: number | undefined;
};

export const NeuronsBadge = ({ showPrice, cost }: TNeuronsBadge) => {
	return (
		<NeuronsCost>
			{showPrice && (cost ?? 0 > 0) ? (
				<>
					<P size="medium" weight={600}>
						{cost}
					</P>
					<Image
						src="/img/neurons/gem-icon.png"
						width={22}
						height={22}
						quality={100}
						alt="neuron image"
					/>
				</>
			) : (
				<P size="small" weight={600}>
					Click to unlock
				</P>
			)}
		</NeuronsCost>
	);
};
